import { ILoadedAudioFiles } from '../../models/LoadedAudioFiles';
import { ActionType } from '../action-types';
import { Action } from '../actions';

const initialState: ILoadedAudioFiles = {
	files: [],
};

const reducer = (state: ILoadedAudioFiles = initialState, action: Action): ILoadedAudioFiles => {
	switch (action.type) {
		case ActionType.AUDIO_FILE_LOADED: {
			if (
				state.files.findIndex((file) => file.id === action.payload.loadedAudioFile.id) >= 0
			) {
				console.error('Trying to add loaded audio file with id that already exists.');
				return state;
			}

			return {
				files: state.files.concat(action.payload.loadedAudioFile),
			};
		}
		case ActionType.RESET_STATE: {
			return initialState;
		}
		default:
			return state;
	}
};

export default reducer;
